import posthog from "posthog-js"

let initialized = false

export function initPostHog(): void {
	if (typeof window === "undefined") return
	const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN
	if (!apiKey || initialized) return
	posthog.init(apiKey, {
		api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://eu.i.posthog.com",
		capture_pageview: false,
		capture_pageleave: true,
		persistence: "localStorage+cookie",
	})
	initialized = true
}

export function trackEvent(event: string, properties?: Record<string, unknown>): void {
	if (!initialized) return
	posthog.capture(event, properties)
}

export function identifyUser(
	user: { id: string; email?: string; name?: string },
	org?: { id: string; name?: string },
): void {
	if (!initialized) return
	posthog.identify(user.id, {
		email: user.email,
		name: user.name,
	})
	if (org?.id) {
		posthog.group("organization", org.id, { name: org.name })
	}
}

export function resetUser(): void {
	if (!initialized) return
	posthog.reset()
}

export function setDemoMode(isDemo: boolean): void {
	if (!initialized) return
	posthog.register({ is_demo: isDemo })
}

export function trackPageview(url: string): void {
	if (!initialized) return
	posthog.capture("$pageview", { $current_url: url })
}
